import React , {memo}from 'react'

import classes from './BreadCrumb.module.scss';
import {useNavigate} from 'react-router-dom';

const BreadCrumb = ({name}) => {
    const navigate = useNavigate();
    return (
        <div className={classes.BreadCrumb}>
            <span className="material-icons" onClick={()=>{navigate('/dashboard/home')}}>
                arrow_back_ios
            </span>
            <h2>
                {name}
            </h2>
        </div>
    )
}

export default memo(BreadCrumb)